import { motion } from 'framer-motion';
import '../styles/Home.css';
import showcaseImage from '../assets/images/showcase.jpg';
function Home() {
  // Animation variants for staggered animations
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.3
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5
      }
    }
  };

  return (
    <motion.div 
      className="home"
      initial="hidden"
      animate="visible"
      variants={containerVariants}
    >
      <motion.div className="hero-section">
        <motion.div 
          className="hero-content"
          variants={itemVariants}
        >
          <motion.div className="showcase-image-container" variants={itemVariants}>
            <img 
              src={showcaseImage} 
              alt="Technology Infrastructure Showcase" 
              className="showcase-image"
            />
          </motion.div>
          <h1>WNA Technology</h1>
          <h2>Cybersecurity Engineer & Systems Architect</h2>
          <p>Delivering robust security solutions and infrastructure optimization 
             with a focus on enterprise-grade protection and scalability</p>
        </motion.div>
        
        <motion.div 
          className="expertise-areas"
          variants={itemVariants}
        >
          <h3>Skills</h3>
          <motion.ul>
            {[
              "Enterprise Security Architecture",
              "Network Infrastructure & Defense",
              "Cloud Security Solutions",
              "System Administration & Automation",
              "Database Security & Management",
              "Full-Stack Development"
            ].map((skill, index) => (
              <motion.li
                key={index}
                whileHover={{ scale: 1.05, x: 10 }}
                whileTap={{ scale: 0.95 }}
                variants={itemVariants}
              >
                {skill}
              </motion.li>
            ))}
          </motion.ul>
          <br></br>
          <br></br>
          <br></br>
        </motion.div>
      </motion.div>
    </motion.div>
  );
}

export default Home; 